import { FormLabel, FormLabelProps, styled } from '@mui/material'

export const Label = styled(FormLabel)<FormLabelProps>({
  borderBottom: 'none',
  fontSize: '0.8rem',
})
